// @ts-nocheck
import { forwardRef, memo } from "react";
export function memoForwardRef(render, propsAreEqual) {
    return memo(forwardRef((props, ref) => render(props, ref)), propsAreEqual);
}
